import { NavigationSourceType, CatalogType } from '@browsing/utils';
import { CardItem } from '../types';

// Define local types to match ArticleCompactCard requirements
type ArticleMediaType = 'IMAGE' | 'VIDEO_LOW';

enum StockStatus {
    RESERVED = 'RESERVED',
    SOLD_OUT = 'SOLD_OUT',
    AVAILABLE = 'AVAILABLE',
}

type ArticleMedia = {
    character_code?: string;
    media_type?: ArticleMediaType;
    length?: any;
    path: string;
    preview_path: string;
    alt_text?: string;
};

type ArticleCardItem = {
    brand: string;
    campaignIdentifier: string;
    media: ArticleMedia[];
    nameCategoryTag: string;
    nameColor: string;
    nameShop: string;
    price: number;
    sku: string;
    specialPrice: number;
};

/**
 * Maps a continue-shopping CardItem to ArticleCardItem (for ArticleCompactCard)
 *
 * @param article - The CardItem from continue-shopping data
 * @returns ArticleCardItem object compatible with ArticleCompactCard
 */
export const mapCardItemToArticleCompactProps = (
    article: CardItem,
): ArticleCardItem & {
    navigationSource: NavigationSourceType;
    catalogType: CatalogType;
    sustainable: boolean;
    stockStatus: StockStatus;
    plusEarlyAccess: boolean;
    withPrimaryColor: boolean;
} => ({
    // Core ArticleCardItem fields (required)
    brand: article.brand,
    campaignIdentifier: article.campaign_identifier,
    media: [
        {
            path: article.media.path,
            preview_path: article.media.preview_path, // Required by ArticleMedia
            alt_text: article.media.alt_text,
            media_type: 'IMAGE' as ArticleMediaType,
        },
    ],
    nameCategoryTag: article.name_category_tag || '', // Use CardItem field
    nameColor: '', // Not available in CardItem
    nameShop: '', // Not available in CardItem
    price: article.price,
    sku: article.sku,
    specialPrice: article.special_price || 0,

    // Extended fields for continue-shopping
    navigationSource: NavigationSourceType.ContinueShopping,
    catalogType: CatalogType.Campaign,
    sustainable: article.sustainable,
    stockStatus: article.stock_status as StockStatus,
    plusEarlyAccess: article.plus_early_access,
    withPrimaryColor: true,
});
